 

<app-charts [chartData]="chartData" [chartContainer]="'candidate-status'"  [chartOpts]="chartOpts"></app-charts>
